import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

type NoteProps = {
	text: string;
	isCentered?: boolean;
	isInputLike?: boolean;
}
export default ({text, isCentered, isInputLike}: NoteProps) => (
	<div className={classNames(
		styles.note,
		isCentered && styles.isCentered,
		isInputLike && styles.isInputLike
	)}>
		{text}
	</div>
)
